export default __webpack_public_path__ + "static/media/para_r_4495_bp.36eefbc0.svg";